export default __webpack_public_path__ + "static/media/assets.9c290286.png";